module.exports = __webpack_public_path__ + "img/schema_siegemoule_3a.bb80d5a5.svg";